import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router,ActivatedRoute } from '@angular/router';
import { NbAuthJWTToken,NbAuthService } from '@nebular/auth';
import { NbToastrService} from '@nebular/theme';
@Component({
  selector: 'ngx-admin-otp',
  templateUrl: './admin-otp.component.html',
  styleUrls: ['./admin-otp.component.scss']
})
export class AdminOtpComponent {
  otp: any;
  alert: any;
  alertflag: number;
  user_id: any;
  enterOtp:any;
  menuArray:string[];
  otpValidation: boolean;
  Role:string;
  constructor(private router : Router,
    public toasterService: NbToastrService,
    private route : ActivatedRoute,
    protected api : ApiService,
    private authService : NbAuthService) {
      this.authService.onTokenChange()
        .subscribe((token: NbAuthJWTToken) => {
        // if(token.getPayload()['role'] !="admin"){
        //   this.router.navigate(['auth/logout'])
        // }
        this.menuArray=token.getPayload()['roles'];
        this.user_id=token.getPayload()['id'];
        this.Role=token.getPayload()['role'];
        if(token.getPayload()['role'] =="admin" || token.getPayload()['role'] =="subAdmin"){
        }else{
          this.router.navigate(['auth/logout'])
        }
      });
    }

  ngOnInit() {
    this.api.postVerifiedOtp(this.user_id,false).subscribe((resp)=>{
    })
    this.api.sendOtp().subscribe(data=>{
      if(data['status'] == 200){
        this.otp = data['data']
      }
    })
  }

  cancel(){
    this.router.navigate(['auth/logout']);
  }


  verify(){
    this.enterOtp = (document.getElementById('enterOtp') as HTMLInputElement).value;
    if(this.otp === this.enterOtp){
        this.api.updateOtp().subscribe(data=>{
          if(data['status'] == 200){
            if(this.Role == "subAdmin"){
              if(this.menuArray.includes('student-management')){
                this.api.postVerifiedOtp(this.user_id,true).subscribe((resp)=>{
                  
                })
                this.router.navigate(['pages/student-management'])
              }else{
                this.api.postVerifiedOtp(this.user_id,true).subscribe((resp)=>{
                  
                })
                this.router.navigate([`pages/${this.menuArray[0]}`])
              }
            }else{
              this.api.postVerifiedOtp(this.user_id,true).subscribe((resp)=>{
                
              })
              this.router.navigate(['pages/student-management'])
            } 
          }
        })
    }else{
      this.otpValidation = false;
      this.toasterService.danger('Invalid Otp','Error',{preventDuplicates:false});

    }
  }
}
